/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [异常列表-异常商品申请赔付↗](http://yapi.yishou.com/project/128/interface/api/33529) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/applyCompensate`
 */
const applyCompensateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/applyCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: { dbids: { type: "array", items: { type: "string" } } },
        required: ["dbids"],
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "applyCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [异常列表-异常商品申请赔付↗](http://yapi.yishou.com/project/128/interface/api/33529) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/applyCompensate`
 */
export const applyCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(applyCompensateRequestConfig, requestData), ...args);
};
applyCompensate.requestConfig = applyCompensateRequestConfig;
/**
 * 接口 [赔付首页-列表↗](http://yapi.yishou.com/project/128/interface/api/33530) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/getIndexList`
 */
const getIndexListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/getIndexList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: {
            pf_no: { type: "string", description: "赔付单号" },
            pgid: { type: "number", description: "采购组id" },
            supply_name: { type: "string", description: "供应商名称" },
            storehouse_id: { type: "number", description: "仓库ID" },
            pf_type: { type: "number", description: "赔付类型" },
            pf_status: { type: "number", description: "赔付状态" },
            pay_tool: { type: "number", description: "支付方式" },
            member_name: { type: "string", description: "采购人名称/仓库名称" },
            is_on_sale: { type: "number", description: "是否包含下架" },
            created_at: { type: "array", items: { type: "string" }, description: "赔付单 创建日期" },
            payment_at: { type: "array", items: { type: "string" }, description: "支付时间" },
            page: { type: "number" },
            pagesize: { type: "number" },
            is_excel: { type: "number" },
            export_ids: { type: "array", items: { type: "string" }, description: "导出id" },
        },
        required: ["created_at"],
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            option_pg: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "采购组",
            },
            option_stock: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "仓库",
            },
            option_compensate_type: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "赔付类型",
            },
            option_compensate_paytool: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "支付方式",
            },
            option_compensate_status: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "赔付状态",
            },
            option_on_sale: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, laebl: { type: "string" } },
                    required: ["key", "laebl"],
                },
                description: "是否买赔",
            },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "赔付id" },
                        pf_no: { type: "string", description: "赔付单号" },
                        pf_created_at: { type: "string", description: "赔付单日期" },
                        pf_type_msg: { type: "string", description: "赔付类型" },
                        pay_tool_msg: { type: "string", description: "支付方式" },
                        supply_name: { type: "string", description: "供应商名称" },
                        city: { type: "string", description: "城市" },
                        market_name: { type: "string", description: "市场" },
                        brand: { type: "string", description: "品牌" },
                        pgname: { type: "string", description: "采购组" },
                        pg_member_name: { type: "string", description: "采购员" },
                        defective_group_member_name: { type: "string", description: "售后退供员" },
                        storehouse_name: { type: "string", description: "仓库" },
                        create_member_name: { type: "string", description: "创建人" },
                        storehouse_member_name: { type: "string", description: "仓库审核人" },
                        storehouse_examine_at: { type: "string", description: "仓库审核时间" },
                        purchase_member_name: { type: "string", description: "采购提交人" },
                        purchase_examine_at: { type: "string", description: "采购提交时间" },
                        goods_num: { type: "string", description: "商品数量" },
                        total_origin_market_price: { type: "number", description: "原拿货总金额" },
                        stock_in_num: { type: "number", description: "入库数量" },
                        total_pf_price: { type: "number", description: "赔付总金额" },
                        diff_price: { type: "number", description: "差额" },
                        status_msg: { type: "string", description: "赔付单状态" },
                        pay_member_name: { type: "string", description: "支付人" },
                        payment_at: { type: "string", description: "支付时间" },
                    },
                    required: [
                        "id",
                        "pf_no",
                        "pf_created_at",
                        "pf_type_msg",
                        "pay_tool_msg",
                        "supply_name",
                        "city",
                        "market_name",
                        "brand",
                        "pgname",
                        "pg_member_name",
                        "defective_group_member_name",
                        "storehouse_name",
                        "create_member_name",
                        "storehouse_member_name",
                        "storehouse_examine_at",
                        "purchase_member_name",
                        "purchase_examine_at",
                        "goods_num",
                        "total_origin_market_price",
                        "stock_in_num",
                        "total_pf_price",
                        "diff_price",
                        "status_msg",
                        "pay_member_name",
                        "payment_at",
                    ],
                },
                description: "列表",
            },
            count: { type: "number", description: "数量" },
        },
    },
    requestFunctionName: "getIndexList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付首页-列表↗](http://yapi.yishou.com/project/128/interface/api/33530) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/getIndexList`
 */
export const getIndexList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getIndexListRequestConfig, requestData), ...args);
};
getIndexList.requestConfig = getIndexListRequestConfig;
/**
 * 接口 [赔付首页-导出赔付明细列表↗](http://yapi.yishou.com/project/128/interface/api/33531) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/exportDetailList`
 */
const exportDetailListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/exportDetailList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: { export_ids: { type: "array", items: { type: "string" }, description: "赔付id数组" } },
        required: ["export_ids"],
    },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string" } } },
    requestFunctionName: "exportDetailList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付首页-导出赔付明细列表↗](http://yapi.yishou.com/project/128/interface/api/33531) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/exportDetailList`
 */
export const exportDetailList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportDetailListRequestConfig, requestData), ...args);
};
exportDetailList.requestConfig = exportDetailListRequestConfig;
/**
 * 接口 [赔付详情-列表↗](http://yapi.yishou.com/project/128/interface/api/33532) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/getDetailList`
 */
const getDetailListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/getDetailList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id"],
        properties: { pf_id: { type: "string", description: "赔付单id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            head_data: {
                type: "object",
                properties: {
                    pf_no: { type: "string", description: "赔付单号" },
                    created_at: { type: "string", description: "创建时间" },
                    status: {
                        type: "string",
                        description: "状态数值 {1:采购待提交\\n,2:已作废,3:仓储待审核,4:采购待重新提交,5:待入库,6:财务待支付,7:已完成}",
                    },
                    status_msg: { type: "string", description: "状态描述" },
                    pay_tool: { type: "string", description: "支付方式{0:转账，2:分账}" },
                    total_goods_num: { type: "integer", description: "总数" },
                    total_pf_price: { type: "number", description: "总价格" },
                },
                description: "顶部数据",
            },
            detail_list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "详情id" },
                        dbid: { type: "string", description: "打标id" },
                        psp_id: { type: "string", description: "前置计划id" },
                        goods_name: { type: "string", description: "商品名称" },
                        goods_img: { type: "string", description: "商品图片" },
                        goods_kh: { type: "string", description: "款号" },
                        goods_no: { type: "string", description: "货号" },
                        co_val: { type: "string", description: "颜色" },
                        si_val: { type: "string", description: "尺码" },
                        sku: { type: "string" },
                        cat_name: { type: "string", description: "分类名称" },
                        stock_source: { type: "string", description: "入库来源" },
                        is_on_sale_msg: { type: "string", description: "商品状态" },
                        exception_source: { type: "string", description: "异常来源" },
                        exception_admin: { type: "string", description: "标记异常人" },
                        exception_time: { type: "string", description: "标记异常时间" },
                        original_market_price: { type: "string", description: "原拿货价" },
                        actual_market_price: { type: "string", description: "实际赔付价" },
                        diff_price: { type: "number", description: "差额" },
                        stock_in_price: { type: "string", description: "入库金额" },
                        new_dbid: { type: "string", description: "新打标ID" },
                        new_stock_source: { type: "string", description: "新入库来源" },
                    },
                    required: [
                        "id",
                        "dbid",
                        "psp_id",
                        "goods_name",
                        "goods_img",
                        "goods_kh",
                        "goods_no",
                        "co_val",
                        "si_val",
                        "sku",
                        "cat_name",
                        "stock_source",
                        "is_on_sale_msg",
                        "exception_source",
                        "exception_admin",
                        "exception_time",
                        "original_market_price",
                        "actual_market_price",
                        "diff_price",
                        "stock_in_price",
                        "new_dbid",
                        "new_stock_source",
                    ],
                },
                description: "详情数组",
            },
            payees: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "支付id" },
                        pay_contact: { type: "string", description: "收款人名称" },
                        pay_bank: { type: "string", description: "开户行名称" },
                        payee_bank: { type: "string", description: "联行号" },
                        pay_account: { type: "string", description: "账号" },
                        is_default: { type: "string", description: "是否默认" },
                    },
                    required: ["id", "pay_contact", "pay_bank", "payee_bank", "pay_account", "is_default"],
                },
                description: "收款人信息",
            },
            operate_log: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        action_admin: { type: "string", description: "操作人" },
                        action_type: { type: "string", description: "操作方式" },
                        action_result: { type: "string", description: "结果" },
                        create_time: { type: "string", description: "操作时间" },
                        action_desc: { type: "string", description: "备注" },
                    },
                    required: ["action_admin", "action_type", "action_result", "create_time", "action_desc"],
                },
            },
        },
    },
    requestFunctionName: "getDetailList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-列表↗](http://yapi.yishou.com/project/128/interface/api/33532) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/getDetailList`
 */
export const getDetailList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getDetailListRequestConfig, requestData), ...args);
};
getDetailList.requestConfig = getDetailListRequestConfig;
/**
 * 接口 [赔付详情-更新实际赔付价格↗](http://yapi.yishou.com/project/128/interface/api/33533) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/updateActualMarketPrice`
 */
const updateActualMarketPriceRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/updateActualMarketPrice",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pfd_id", "actual_market_price"],
        properties: {
            pfd_id: { type: "string", description: "赔付单详情id" },
            actual_market_price: { type: "string", description: "实际赔付价" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "updateActualMarketPrice",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-更新实际赔付价格↗](http://yapi.yishou.com/project/128/interface/api/33533) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/updateActualMarketPrice`
 */
export const updateActualMarketPrice = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateActualMarketPriceRequestConfig, requestData), ...args);
};
updateActualMarketPrice.requestConfig = updateActualMarketPriceRequestConfig;
/**
 * 接口 [赔付详情-作废赔付单↗](http://yapi.yishou.com/project/128/interface/api/33534) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/cancelCompensate`
 */
const cancelCompensateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/cancelCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id", "log_remark"],
        properties: { pf_id: { type: "string" }, log_remark: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "cancelCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-作废赔付单↗](http://yapi.yishou.com/project/128/interface/api/33534) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/cancelCompensate`
 */
export const cancelCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(cancelCompensateRequestConfig, requestData), ...args);
};
cancelCompensate.requestConfig = cancelCompensateRequestConfig;
/**
 * 接口 [赔付详情-采购提交赔付单↗](http://yapi.yishou.com/project/128/interface/api/33535) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/purchaseAdoptCompensate`
 */
const purchaseAdoptCompensateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/purchaseAdoptCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id", "payee_id"],
        properties: {
            pf_id: { type: "string", description: "赔付单id" },
            log_remark: { type: "string", description: "日志备注" },
            payee_id: { type: "string", description: "收款信息id ，分支支付也需要传" },
        },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "purchaseAdoptCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-采购提交赔付单↗](http://yapi.yishou.com/project/128/interface/api/33535) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/purchaseAdoptCompensate`
 */
export const purchaseAdoptCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(purchaseAdoptCompensateRequestConfig, requestData), ...args);
};
purchaseAdoptCompensate.requestConfig = purchaseAdoptCompensateRequestConfig;
/**
 * 接口 [赔付详情-仓储通过赔付单↗](http://yapi.yishou.com/project/128/interface/api/33536) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/storehouseAdoptCompensate`
 */
const storehouseAdoptCompensateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/storehouseAdoptCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id", "log_remark"],
        properties: { pf_id: { type: "string", description: "赔付id" }, log_remark: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "storehouseAdoptCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-仓储通过赔付单↗](http://yapi.yishou.com/project/128/interface/api/33536) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/storehouseAdoptCompensate`
 */
export const storehouseAdoptCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(storehouseAdoptCompensateRequestConfig, requestData), ...args);
};
storehouseAdoptCompensate.requestConfig = storehouseAdoptCompensateRequestConfig;
/**
 * 接口 [赔付详情-仓储驳回赔付单↗](http://yapi.yishou.com/project/128/interface/api/33537) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/rejectCompensate`
 */
const rejectCompensateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/rejectCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id", "log_remark"],
        properties: { pf_id: { type: "string" }, log_remark: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "rejectCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-仓储驳回赔付单↗](http://yapi.yishou.com/project/128/interface/api/33537) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/rejectCompensate`
 */
export const rejectCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(rejectCompensateRequestConfig, requestData), ...args);
};
rejectCompensate.requestConfig = rejectCompensateRequestConfig;
/**
 * 接口 [入库日志-批量转入\/转出异常状态↗](http://yapi.yishou.com/project/128/interface/api/33538) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/editStockException?import=1`
 */
const editStockExceptionImport_1RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/editStockException?import=1",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["dbids", "markType", "is_pc", "exceptionSource", "file"],
        properties: {
            dbids: { type: "string" },
            markType: { type: "string", description: "下载模板，批量导入时需带上参数{1：标记异常，2：恢复正常}" },
            is_pc: { type: "string", description: "" },
            exceptionSource: { type: "string", description: "异常来源 (1:其他异常,4:改标异常)" },
            file: { type: "file", description: "", tsType: "FileData" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            errMsg: { type: "string", description: "错误描述" },
            file: { type: "string", description: "文件路径" },
        },
        required: ["file"],
    },
    requestFunctionName: "editStockExceptionImport_1",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [入库日志-批量转入\/转出异常状态↗](http://yapi.yishou.com/project/128/interface/api/33538) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/editStockException?import=1`
 */
export const editStockExceptionImport_1 = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(editStockExceptionImport_1RequestConfig, requestData), ...args);
};
editStockExceptionImport_1.requestConfig = editStockExceptionImport_1RequestConfig;
/**
 * 接口 [商品入库列表↗](http://yapi.yishou.com/project/128/interface/api/33541) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `GET /erp/StockInRecord/list`
 */
const listRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["is_compensate"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_compensate"],
        properties: { is_compensate: { type: "string", description: "是否买赔商品" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            optionsPg: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsMs: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: ["number", "string"] }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsType: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsOrigin: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsWhere: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" }, count: { type: "number" } },
                    required: ["key", "label", "count"],
                },
            },
            optionsStatus: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsLevel: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsblp: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionPurchaseDaBiaoMethod: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            exceptionSourceOp: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsPiciType: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionsPgMember: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "string" } },
                    required: ["label", "value"],
                },
            },
            owner_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            dg_group: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            option_dgm: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            dgm_refunder: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            signExceptionSourceOp: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "标记异常来源",
            },
            optionIsCompensate: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "是否买赔",
            },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: { is_compensate_msg: { type: "string", description: "买赔商品描述" } },
                    required: ["is_compensate_msg"],
                },
            },
        },
        required: ["optionIsCompensate", "list"],
    },
    requestFunctionName: "list",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [商品入库列表↗](http://yapi.yishou.com/project/128/interface/api/33541) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `GET /erp/StockInRecord/list`
 */
export const list = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listRequestConfig, requestData), ...args);
};
list.requestConfig = listRequestConfig;
/**
 * 接口 [异常列表-标记异常dbid列表↗](http://yapi.yishou.com/project/128/interface/api/33545) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/exceptionList`
 */
const exceptionListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/exceptionList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["cause_id", "rd_id", "r_personnel"],
        properties: {
            cause_id: { type: "string", description: "异常原因ID" },
            rd_id: { type: "string", description: "责任部门ID" },
            r_personnel: { type: "string", description: "责任人" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        dbid: { type: "string" },
                        id: { type: "string", description: "异常商品的ID" },
                        exception_dbid_source: { type: "string" },
                        goods_no: { type: "string" },
                        exception_admin_name: { type: "string" },
                        exception_time: { type: "string" },
                        stock_in_time: { type: "string" },
                        goods_no_co_si_val: { type: "string" },
                        goods_name: { type: "string" },
                        sku: { type: "string" },
                        supply_market_brand: { type: "string" },
                        cat_name: { type: "string" },
                        da_biao_record_type: { type: "string" },
                        stock_in_record_stock_source: { type: "string" },
                        storehouse_id: { type: "string" },
                        status: { type: "string", description: "商品异常状态{1:异常待处理,2:审核中}" },
                        stock_in_record_origin: { type: "string" },
                        goods_img: { type: "array", items: { type: "string" } },
                        exception_status_msg: { type: "string", description: "商品异常状态" },
                        cause_id: { type: "number" },
                        responsibility_department_id: { type: "number" },
                        responsibility_personnel: { type: "string", description: "责任人" },
                        cause: { type: "string", description: "异常原因" },
                        responsibility_department: { type: "string", description: "责任部门" },
                        edit_user_name: { type: "string", description: "修改人" },
                        edit_datetime: { type: "string", description: "修改时间" },
                    },
                    required: [
                        "dbid",
                        "exception_dbid_source",
                        "goods_no",
                        "exception_admin_name",
                        "exception_time",
                        "stock_in_time",
                        "goods_no_co_si_val",
                        "goods_name",
                        "sku",
                        "supply_market_brand",
                        "cat_name",
                        "da_biao_record_type",
                        "stock_in_record_stock_source",
                        "storehouse_id",
                        "status",
                        "stock_in_record_origin",
                        "goods_img",
                        "exception_status_msg",
                        "id",
                        "responsibility_personnel",
                        "responsibility_department_id",
                        "cause_id",
                        "edit_datetime",
                        "edit_user_name",
                        "responsibility_department",
                        "cause",
                    ],
                },
            },
            total: { type: "number" },
            exception_source_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
            },
            stock_in_stock_source_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
            },
            stock_in_record_origin_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
            },
        },
    },
    requestFunctionName: "exceptionList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [异常列表-标记异常dbid列表↗](http://yapi.yishou.com/project/128/interface/api/33545) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/StockInRecord/exceptionList`
 */
export const exceptionList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exceptionListRequestConfig, requestData), ...args);
};
exceptionList.requestConfig = exceptionListRequestConfig;
/**
 * 接口 [赔付详情-打标-赔付打标↗](http://yapi.yishou.com/project/128/interface/api/33550) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/goodsCompensate/pFDaBiao`
 */
const pFDaBiaoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/goodsCompensate/pFDaBiao",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id"],
        properties: {
            pf_id: { type: "string", description: "赔付id" },
            dbid: { type: "string", description: "旧的dbid，可为空，为空则显示数量和已打标数据" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            dbidCount: { type: "number", description: "打标数量" },
            newDbid: { type: "array", items: { type: "string" }, description: "新打标id" },
        },
    },
    requestFunctionName: "pFDaBiao",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-打标-赔付打标↗](http://yapi.yishou.com/project/128/interface/api/33550) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/goodsCompensate/pFDaBiao`
 */
export const pFDaBiao = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(pFDaBiaoRequestConfig, requestData), ...args);
};
pFDaBiao.requestConfig = pFDaBiaoRequestConfig;
/**
 * 接口 [赔付详情-提交打标数据并入库↗](http://yapi.yishou.com/project/128/interface/api/33551) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/submitDbid`
 */
const submitDbidRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/submitDbid",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id"],
        properties: { pf_id: { type: "string", description: "赔付id" } },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "submitDbid",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-提交打标数据并入库↗](http://yapi.yishou.com/project/128/interface/api/33551) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/submitDbid`
 */
export const submitDbid = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(submitDbidRequestConfig, requestData), ...args);
};
submitDbid.requestConfig = submitDbidRequestConfig;
/**
 * 接口 [赔付详情-打标-撤标↗](http://yapi.yishou.com/project/128/interface/api/33552) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/removeDbid`
 */
const removeDbidRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/removeDbid",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["new_dbid", "pf_id"],
        properties: {
            new_dbid: { type: "string", description: "新打标id，可以是数组 也可以是单个打标id" },
            pf_id: { type: "string", description: "赔付单id" },
        },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "removeDbid",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-打标-撤标↗](http://yapi.yishou.com/project/128/interface/api/33552) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/removeDbid`
 */
export const removeDbid = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(removeDbidRequestConfig, requestData), ...args);
};
removeDbid.requestConfig = removeDbidRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/preStockManage3155.js